import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';
import { APROBADO, REGISTRADO, ANULADO, RECHAZADO } from '../../../common/types/requerimientoEstadoType';

export default function ResultList(props) {
    const renderColor = (row) => {
        if (row.idRequerimientoEstado === REGISTRADO)
            return 'blue';
        if (row.idRequerimientoEstado === APROBADO)
            return 'green';
        if (row.idRequerimientoEstado === RECHAZADO)
            return 'orange';
        if (row.idRequerimientoEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onVer(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Aprobar">
                                <Button
                                    type="success"
                                    size={"small"}
                                    icon={"check"}
                                    onClick={() => props.onAprobar(row)}
                                    disabled={row.idRequerimientoEstado === REGISTRADO ? false : true}
                                >
                                </Button>
                            </Tooltip>
                            <Tooltip placement="top" title="Rechazar">
                                <Button
                                    type="danger"
                                    icon="close"
                                    size={"small"}
                                    onClick={() => props.onRechazar(row)}
                                    disabled={row.idRequerimientoEstado === REGISTRADO ? false : true}
                                />
                            </Tooltip>
                   
                            <Tooltip placement="top" title="Imprimir">
                                <Button
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                    onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                //{
                //    title: 'Tipo Documento',
                //    dataIndex: 'tipoDocumentoCliente',
                //    key: 'tipoDocumentoCliente',
                //    sorter: true
                //},
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumento',
                    key: 'numeroDocumento',
                    sorter: true
                },
                {
                    title: 'Cliente',
                    dataIndex: 'razonSocial',
                    key: 'razonSocial',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreRequerimientoEstado',
                    key: 'nombreRequerimientoEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );

}

